import React from 'react';
import style from 'styled-components';
import { Palette } from 'core/config';

interface Props
{
    success  : boolean;
    message? : string; 
}

export const VerificationStatus : React.FunctionComponent<Props> = ({ 
    success,
    message
}) =>
{
    return (
        <Container>
            <Header>
                {success 
                    ? 'Your Manzil account has been verified' 
                    : 'An error occurred while verifying your account'
                }
            </Header>
            {success ? (
                <Paragraph>
                    Please <a href="/login">login to your account</a> now to complete the process.
                </Paragraph>
            ) : message ? (
                <Paragraph>
                    {message}
                </Paragraph>
            ) : (
                <Paragraph>
                    If you have any questions or concerns, please feel free to email us at <a href="mailto:salaam@manzil.ca">salaam@manzil.ca</a>.
                </Paragraph>
            )}
            <Paragraph></Paragraph>
        </Container>
    );
};

const Container = style.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: calc(100vh - 232px);

    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
`;

const Header = style.div`
    flex-direction: row;
    color: ${Palette.BLUE};
    font: normal normal normal 27px 'SofiaPro-Bold';
    font-weight: 500;
    line-height: 28px;
    text-align: center;

    @media only screen and (max-width: 600px) {
        font-size: 21px;
    }
`;

const Paragraph = style.p`
    flex-direction: row;
    font: normal normal normal 12px 'SofiaPro-Regular';
    color: ${Palette.BLUE};
    font-weight: light;
    text-align: center;

    :last-child {
        margin-top: -5px;
    }

    @media only screen and (min-width: 1300px) {
        font-size: 14px;
    }

    @media only screen and (min-width: 1900px) {
        font-size: 16px;
    }
`;